// Distance + height unit helpers.
// Distance is canonically stored in METERS, height in INCHES.

const METERS_PER_FOOT = 0.3048;
const METERS_PER_INCH = 0.0254;
const FEET_PER_METER = 1 / METERS_PER_FOOT;       // ≈ 3.2808399
const INCHES_PER_METER = 1 / METERS_PER_INCH;     // ≈ 39.3700787
const INCHES_PER_FOOT = 12;

const round1 = (n) => Math.round(n * 10) / 10;
const round2 = (n) => Math.round(n * 100) / 100;

// ── Distance ──────────────────────────────────────────────

/** Convert a (value, unit) form input → canonical meters (Number) or null. */
export function toCanonicalMeters(value, unit) {
  if (value === null || value === undefined || value === "") return null;
  const n = Number(value);
  if (Number.isNaN(n)) return null;
  if (unit === "ft") return round2(n * METERS_PER_FOOT);
  if (unit === "in") return round2(n * METERS_PER_INCH);
  return round2(n);
}

/** Convert canonical meters → display value in target unit (1 decimal). */
export function fromCanonicalMeters(meters, unit) {
  if (meters === null || meters === undefined || meters === "") return null;
  const n = Number(meters);
  if (Number.isNaN(n)) return null;
  if (unit === "ft") return round1(n * FEET_PER_METER);
  if (unit === "in") return round1(n * INCHES_PER_METER);
  return round1(n);
}

/** Format canonical meters as e.g. "400 m" / "5 ft" / "20 in". */
export function formatStoredDistance(meters, unit) {
  const v = fromCanonicalMeters(meters, unit);
  if (v == null) return "";
  const txt = (Math.round(v * 10) % 10 === 0) ? String(Math.round(v)) : String(v);
  return `${txt} ${unit || "m"}`;
}

// ── Height ────────────────────────────────────────────────

/** Convert a (value, unit) form input → canonical inches (Number) or null. */
export function toCanonicalInches(value, unit) {
  if (value === null || value === undefined || value === "") return null;
  const n = Number(value);
  if (Number.isNaN(n)) return null;
  if (unit === "ft") return round2(n * INCHES_PER_FOOT);
  return round2(n);
}

/** Convert canonical inches → display value in target unit (1 decimal). */
export function fromCanonicalInches(inches, unit) {
  if (inches === null || inches === undefined || inches === "") return null;
  const n = Number(inches);
  if (Number.isNaN(n)) return null;
  if (unit === "ft") return round1(n / INCHES_PER_FOOT);
  return round1(n);
}

/** Format canonical inches as e.g. `24 in` or `2 ft`. */
export function formatStoredHeight(inches, unit) {
  const v = fromCanonicalInches(inches, unit);
  if (v == null) return "";
  const txt = (Math.round(v * 10) % 10 === 0) ? String(Math.round(v)) : String(v);
  return `${txt} ${unit || "in"}`;
}
